// Copyright (c) 2016 Deere & Company

import './option-codes-panel.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import AddOptionForm from './add-option-form';
import DownloadToExcelForPanel from '../../../shared/components/download-to-excel-for-panel';
import {FormattedMessage} from 'react-intl';
import Option from '@deere/cps-it.warranty-model-factory/lib/option';
import OptionCodesList from './option-codes-list';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {exportToExcel} from '../../../shared/services/export-to-excel';

const OptionCodesPanel = (props, context) => {

    const optionCodesPanelHeader = (
        <span>
            <FormattedMessage id='OPTION_CODES'/>{` (${props.options.length})`}
        </span>
    );

    const downloadToExcelEl = props.options.length ? (
        <DownloadToExcelForPanel onDownload={() => exportToExcel(`/api/products/${props.pin}/options?export=EXCEL&language=${context.user.getLocale()}`)}/>) : null;

    const optionCodesPanelBody = (
        <div>
            {props.canAddDeleteOption &&
                <AddOptionForm
                    onCreateOption={props.onCreateOption}
                    onInputChange={props.onInputChange}
                    option={props.option}
                />
            }
            <div className='column-titles'>
                <span className='option-codes-header'>
                    <FormattedMessage id='CODE'/>
                </span>
                <span className='description-header'>
                    <FormattedMessage id='DESCRIPTION'/>
                </span>
                <span className='created-header'>
                    <FormattedMessage id='CREATED'/>
                </span>
                <span className='changed-header'>
                    <FormattedMessage id='DELETED'/>
                </span>
                <span className='changed-by-header'>
                    <FormattedMessage id='DELETED_BY'/>
                </span>
                <span className='delete-icon'/>
            </div>
            <OptionCodesList
                canAddDeleteOption={props.canAddDeleteOption}
                onDelete={props.onDelete}
                options={props.options}
            />
        </div>
    );

    return (
        <Accordion
            accordionId='option-codes-accordion'
            body={optionCodesPanelBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            secondaryHeaderNode={downloadToExcelEl}
            title={optionCodesPanelHeader}
        />
    );

};

OptionCodesPanel.displayName = 'OptionCodesPanel';
OptionCodesPanel.propTypes = {
    canAddDeleteOption: PropTypes.bool.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onCreateOption: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    option: PropTypes.instanceOf(Option).isRequired,
    options: PropTypes.arrayOf(PropTypes.instanceOf(Option)).isRequired,
    pin: PropTypes.string.isRequired
};
OptionCodesPanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default OptionCodesPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/option-codes-panel.js